/** @jsxImportSource @emotion/react */

import type { ComponentPropsWithRef, ElementType } from "react";
import { forwardRef } from "react";
import { numberBadgeCSS, variantMap } from "./NumberBadge.css";
import type { NumberBadgeProps } from "./NumberBadge.types";

type NumberBadgeComponent = <E extends ElementType>(
  props: NumberBadgeProps<E> & {
    ref?: ComponentPropsWithRef<E>["ref"];
  },
) => JSX.Element | null;

export const NumberBadge: NumberBadgeComponent = forwardRef(function ClayNumberBadge<
  E extends ElementType,
>(
  { number, as, size = "medium", native, sx, variant, className }: NumberBadgeProps<E>,
  ref: ComponentPropsWithRef<E>["ref"],
) {
  const Element = as || "span";

  return (
    <Element
      ref={ref}
      className={className}
      {...native}
      style={{
        ...variantMap.variant[variant],
        ...variantMap.size[size],
        ...native?.style,
      }}
      css={[numberBadgeCSS, sx]}
    >
      {number}
    </Element>
  );
});
